<template>
  <div class="go-top" @click="goTop"></div>
</template>

<script>

export default {
  name: 'FootView',
  data() {
    return {
    }
  },
  methods: {
    // 返回顶部
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
  }
}
</script>
<style scoped lang="scss">
.go-top {
  z-index: 15;
  position:fixed;
  right: 40px;
  bottom: 80px;
  width: 102px;
  height: 102px;
  cursor: pointer;
  background: url('../../assets/up2.png') no-repeat;
  background-size: 100%;
}
.go-top:hover {
  background: url('../../assets/up.png') no-repeat;
  background-size: 100%;
}
</style>
